import { Stack } from "@mui/material";
import ContentEditable from "react-contenteditable";
import { styled } from '@mui/material/styles';
import { keyframes } from '@mui/system';

export const StyledContentEditableContainer = styled(Stack, {
  name: 'ContentEditable',
  slot: 'container'
})(({ theme }) => ({
  placeItems: 'center',
  padding: '4px 10px',
  borderRadius: theme.palette.borderRadius,
  border: `1px solid ${theme.palette.grey[300]}`,
  '&:hover': {
    borderColor: theme.palette.action.active,
  },
  '&.is-focused': {
    border: `1px solid ${theme.palette.primary.main}`,
    boxShadow: `inset 0 0 0 1px ${theme.palette.primary.main}`,
  },
}));

export const StyledContentEditableContent = styled(ContentEditable, {
  name: 'MuiContentEditable',
  slot: 'content',
  shouldForwardProp: prop => !['isFocused'].includes(prop)
})(({ theme, isFocused }) => ({
  minWidth: '3ch',
  fontFamily: 'monospace',
  fontSize: '1em',
  fontWeight: 400,
  lineHeight: 1,
  outline: 'none',
  animation: isFocused ? `${keyframes`
      0% {
        background-color: ${theme.palette.action.focus}
      } 
      50% {
        background-color: ${theme.palette.action.disabled}
      }
      100% {
        background-color: ${theme.palette.action.focus}
      }
  `} 1500ms infinite ease` : null,
  // backgroundColor: isFocused ? theme.palette.action.focus : theme.palette.background.paper,
  backgroundColor: 'transparent',
  // '&::selection': {
  //   backgroundColor: 'transparent',
  // },
}));